"use strict";

//
//
//
//
//
//
//
//
//
//
//

module.exports = {
  computed: {
    imagePath: function imagePath() {
      if (this.src != "") {
        return this._isHttpOrFile(this.src) ? this.src : this._getContext() + this.src;
      }
    },
    placeholderPath: function placeholderPath() {
      if (this.placeholder != "") {
        return this._isHttpOrFile(this.placeholder) ? this.placeholder : this._getContext() + this.placeholder;
      }
    }
  },
  props: {
    width: {
      type: String
    },
    height: {
      type: String
    },
    src: {
      type: String
    },
    resize: {
      type: String,
      default: "stretch"
    },
    placeholder: {
      type: String,
      default: ""
    },
    radius: {
      type: [String, Number],
      default: "0px"
    }
  },
  methods: {
    _click: function _click(e) {
      this.$emit("click", e);
    },
    _load: function _load() {
      this.$emit("load");
    },
    _isHttpOrFile: function _isHttpOrFile(path) {
      //http file base64
      return path.indexOf("http") == 0 || path.indexOf("file") == 0 || path.indexOf("data:image") == 0;
    },
    _getContext: function _getContext() {
      var url = weex.config.bundleUrl;
      if (url.indexOf("?") > 0) {
        url = url.substring(0, url.indexOf("?"));
      }
      url = url.split("/").slice(0, -1).join("/");
      if (this._isHttpOrFile(url)) {
        return url;
      } else {
        if (url.indexOf("/") == 0) {
          url = url.substring(url.indexOf("/") + 1);
        }
        url = "file:///android_asset" + (url == "" ? "" : "/") + url;
      }
      return url;
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/script-loader.js!./~/babel-loader/lib!./~/weex-vue-loader/lib/selector.js?type=script&index=0!./packages/dof-image/index.vue
// module id = 337
// module chunks = 0 1